export type YesNoType = 'YES' | 'NO' | '';

export type NoYes_DefaultNoType = 'YES' | 'NO' | 'N_y';

export const TABLETMIN = 768;

export class DpBooleanValueTypes {
    public static readonly Y_n : DpBooleanValue = "Y_n";
    public static readonly N_y : DpBooleanValue = "N_y";
    public static readonly YES : DpBooleanValue = "YES";
    public static readonly NO  : DpBooleanValue = "NO";
    public static readonly BLANK : DpBooleanValue = "";
}


export type DpBooleanValue = "YES" | "NO" | "Y_n" | "N_y" | "";

export const PostalCodePatern = {
    Canada : '[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]',
    USA: '(\\d{5}([\\-]\\d{4})?)'
};

export const PostalCodeExample = {
    Canada : 'A0A 0A0',
    USA: 'nnnnn-nnnn'
};

export const CANDADIAN_DRIVER_LICENCE_ID = "Driver's Licence - Canadian";
export const PASSPORT_CANADIAN_ID = "Passport - Canadian";

export const UploadedFileDescription = {
    permanentResidentCard : 'Permanent Resident Card',
    mortgageStatement: 'Mortgage Statement',
    mostRecentTaxBill: 'Most Recent Tax Bill',
    driverLicenseFront: "Driver's Licence Front",
    driverLicenseBack: "Driver's Licence Back",
    passportCanadianId: "Personal data page of the Passport - Canadian",
    frontDescription : "Front",
    backDescription : "Back"

};

export const IdentificationOptions = {
    birthCertificate: 'Birth Certificate',
    driverLicense: "Driver's License",
    canadianPassport: 'Canadian Passport',
    certificateOfCanadianCitizenship: 'Certificate of Canadian Citizenship',
    certificateOfNaturalization: 'Certificate of Naturalization',
    permanentResidenceCard: 'Permanent Residence Card',
    foreignPassport: 'Foreign Passport'

};

export const CREDIT_CARD = 'Credit Card';

export const identificationStatus = {
    primary: 'PRIMARY',
    secondary: 'SECONDARY'
};

export const PROVINCE_CODES = {
    ONTARIO: 'ON',
    NEW_BRUNSWICK: 'NB',
    NOVA_SCOTIA: 'NS',
    ALBERTA: 'AB',
    MANITOBA: 'MB',
    SASKATCHEWAN: 'SK',
    BRITISH_COLOMBIA: 'BC'
};

export const CIRF_NAME_KEYS = {

    contactInfo: {title: 'Contact Info', key: 'CONTACT_INFO'},
    personalDetails: {title: 'Personal Details', key: 'PERSONAL_DETAILS'},
    contactDetails: {title: 'Contact Details', key: 'Contact_DETAILS'},
    idVerification1: {title: 'Identification Verification #1', key: 'ID_VERIFICATION1'},
    idVerification2: {title: 'Identification Verification #2', key: 'ID_VERIFICATION2'},

    clientNotesTopic: {title: 'Client Notes', key: 'CLIENT_NOTES'},
    clientNotes: {title: 'Notes', key: 'CLIENT_NOTES'},

    transactionDetails: {title: 'Transaction Details', key: 'TRANSACTION_DETAILS'},
    matterContactInfo: {title: 'Matter Contact Info', key: 'MATTER_CONTACT_INFO'},
    newInsuranceDetails: {title: 'New Insurance Details', key: 'NEW_INSURANCE_DETAILS'},

    newMortgageNoteTopic: {title: 'Mortgage Notes', key: 'NEW_MORTGAGE_NOTES'},
    newMortgageNotes: {title: 'Notes', key: 'SUB_NEW_MORTGAGE_NOTE'},

    existingMortgageNoteTopic: {title: 'Existing Mortgage Notes', key: 'EXISTING_MORTGAGE_NOTES'},
    existingMortgageNotes: {title: 'Notes', key: 'SUB_EXISTING_MORTGAGE_NOTE'},

    additionalNotes: {title: 'Additional Topics', key: 'ADDITIONAL_NOTES'},
    matterNotes: {title: 'Additional Note(s)', key: 'MATTER_NOTES'},
    additionalAttachments: {title: 'Additional Attachment(s)', key: 'ADDITIONAL_ATTACHMENT'},
    reviewSubmit: {title: 'Review & Submit', key: 'REVIEW_SUBMIT'},


};

export const CIRF_CLIENT_TOPICS = [
    {
        topicName: CIRF_NAME_KEYS.contactInfo.title,
        topicKey: CIRF_NAME_KEYS.contactInfo.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.personalDetails.title, sectionKey:CIRF_NAME_KEYS.personalDetails.key},
            {sectionName: CIRF_NAME_KEYS.contactDetails.title, sectionKey:CIRF_NAME_KEYS.contactDetails.key},
            {sectionName: CIRF_NAME_KEYS.idVerification1.title, sectionKey:CIRF_NAME_KEYS.idVerification1.key},
            {sectionName: CIRF_NAME_KEYS.idVerification2.title, sectionKey:CIRF_NAME_KEYS.idVerification2.key}
        ]
    }
];

export const CIRF_OTHER_TOPICS = [
    {
        topicName: CIRF_NAME_KEYS.clientNotesTopic.title,
        topicKey: CIRF_NAME_KEYS.clientNotesTopic.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.clientNotes.title, sectionKey:CIRF_NAME_KEYS.clientNotes.key},

        ]
    },
    {
        topicName: CIRF_NAME_KEYS.transactionDetails.title,
        topicKey: CIRF_NAME_KEYS.transactionDetails.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.matterContactInfo.title, sectionKey:CIRF_NAME_KEYS.matterContactInfo.key},
            {sectionName: CIRF_NAME_KEYS.newInsuranceDetails.title, sectionKey:CIRF_NAME_KEYS.newInsuranceDetails.key},

        ]
    }
];

export const CIRF_NEW_MORTGAGE_NOTES_TOPICS = [
    {
        topicName: CIRF_NAME_KEYS.newMortgageNoteTopic.title,
        topicKey: CIRF_NAME_KEYS.newMortgageNoteTopic.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.newMortgageNotes.title, sectionKey:CIRF_NAME_KEYS.newMortgageNotes.key},

        ]
    },
];

export const CIRF_EXISTING_MORTGAGE_NOTES_TOPICS = [
    {
        topicName: CIRF_NAME_KEYS.existingMortgageNoteTopic.title,
        topicKey: CIRF_NAME_KEYS.existingMortgageNoteTopic.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.existingMortgageNotes.title, sectionKey:CIRF_NAME_KEYS.existingMortgageNotes.key},

        ]
    },
];

export const CIRF_ADDITIONAL_TOPICS = [
    {
        topicName: CIRF_NAME_KEYS.additionalNotes.title,
        topicKey: CIRF_NAME_KEYS.additionalNotes.key,
        topicSections : [
            {sectionName: CIRF_NAME_KEYS.matterNotes.title, sectionKey:CIRF_NAME_KEYS.matterNotes.key},
            {sectionName: CIRF_NAME_KEYS.additionalAttachments.title, sectionKey:CIRF_NAME_KEYS.additionalAttachments.key},
            {sectionName: CIRF_NAME_KEYS.reviewSubmit.title, sectionKey:CIRF_NAME_KEYS.reviewSubmit.key},
        ]
    }
];

export const CLIENT_SECTIONS_FOR_ERROR_VALIDATION = [
    { sectionList : ['firstName','middleName', 'lastName', 'gender', 'birthDate'] , sectionErrorField: 'hasPersonalDetailsSectionErrors' },
    { sectionList : ['email', 'firstTimeHomeBuyer', 'isCanadianResident','residentStatus', 'spousalStatus', 'isFamilyResidence','isSpouseOnTitle' , 'spouseName',
            'telephoneNumber', 'occupation', 'addressLine1', 'addressLine2', 'city', 'provinceCode', 'postalCode'] ,
        sectionErrorField: 'hasContactDetailsSectionErrors' }
]





